/* eslint-disable */
import { useEffect, useState, useMemo, Fragment } from "react";
import PrevilegeHeader from "./Header/PrevilegeHeader";
import { assetImages } from "constants";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import PreviledgeSuccessModal from "components/CRMComponents/CRMLeadListComponents/Modal/PreviledgeSuccessModal";
import { useTranslation } from "react-i18next";

const ModuleRolePrevilegeBody = () => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { t } = useTranslation(); //for translation
  const [isLoading, setIsLoading] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const [previleges, setPrevileges] = useState([]);

  const [isSaving, setisSaving] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [expandedParents, setExpandedParents] = useState(new Set());

  //function for get all tags
  const getAllRoles = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_ROLES +
        `?token=${token}&filterfeatured=${true}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setRoleList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const organizeByParent = (data) => {
    const roots = data
      .filter((item) => item.parent === null)
      .sort((a, b) => a.rank - b.rank);
    const result = [];
    roots.forEach((root) => {
      result.push(root);
      const children = data
        .filter((item) => item.parent === root.moduleid)
        .sort((a, b) => a.rank - b.rank);
      result.push(...children);
    });
    return result;
  };

  // Grouped structure for accordion rendering
  const groupedData = useMemo(() => {
    const roots = previleges
      .filter((item) => item.parent === null)
      .sort((a, b) => a.rank - b.rank);
    return roots.map((root) => ({
      parent: root,
      children: previleges
        .filter((item) => item.parent === root.moduleid)
        .sort((a, b) => a.rank - b.rank),
    }));
  }, [previleges]);

  //function for get all modules
  const getAllModulePrevileges = async () => {
    try {
      setIsLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_MODULE_ROLE_PREVILEGES +
        `?token=${token}`;

      console.log('Role Priviledge --',requestUrl);

      const response = await getData(requestUrl);

      console.log(response);

      setIsLoading(false);

      if (response.status) {
        setPrevileges(organizeByParent(response.data));
        setExpandedParents(new Set());
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const toggleExpand = (moduleid) => {
    setExpandedParents((prev) => {
      const next = new Set(prev);
      if (next.has(moduleid)) {
        next.delete(moduleid);
      } else {
        next.add(moduleid);
      }
      return next;
    });
  };

  //change previlege — cascades to children when parent is toggled
  const changePrevilegeCheckHandler = (e, previlegeData, moduleData) => {
    const isChecked = e.target.checked;
    const isParent = moduleData.parent === null;

    const updatedPrevilegeModules = previleges.map((dataItem) => {
      // Update the directly changed module
      if (dataItem.slug === moduleData.slug) {
        const updatedPrevileges = dataItem.previleges.map((p) => {
          if (p.slug === previlegeData.slug) {
            return { ...p, privilege: isChecked };
          }
          return p;
        });
        return { ...dataItem, previleges: updatedPrevileges };
      }

      // If parent row changed, cascade same privilege column to all children
      if (isParent && dataItem.parent === moduleData.moduleid) {
        const updatedPrevileges = dataItem.previleges.map((p) => {
          if (p.slug === previlegeData.slug) {
            return { ...p, privilege: isChecked };
          }
          return p;
        });
        return { ...dataItem, previleges: updatedPrevileges };
      }

      return dataItem;
    });

    setPrevileges(updatedPrevilegeModules);
  };

  //save previlege
  const savePrevilegeHandler = async () => {
    setisSaving(true);
    try {
      let previlegeData = {
        previlegearr: previleges,
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_MODULE_ROLE_PREVILEGE +
        `?token=${token}`;

      const response = await postData(requestUrl, previlegeData);

      setisSaving(false);
      // console.log(response);
      if (response.status) {
        const bootstrapModal = new bootstrap.Modal(
          document.getElementById("afterSavePreviledgeModal")
        );
        bootstrapModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getAllRoles();
    getAllModulePrevileges();
  }, []);

  if (userInfo.role.slug === "ADMIN" || userInfo.role.slug === "SUPER_ADMIN") {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="container-fluid px-lg-5">
            <PrevilegeHeader
              reloadList={getAllModulePrevileges}
              savePrevilegeHandler={savePrevilegeHandler}
              isSaving={isSaving}
            />
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper" style={{ overflowY: "auto", maxHeight: "70vh" }}>
                <table
                  id="module_role_privilege"
                  className="table display nowrap"
                  style={{ width: "100%" }}
                >
                  <thead style={{ position: "sticky", top: 0, zIndex: 10 }}>
                    <tr>
                      <th
                        className="module fw-semibold"
                        style={{
                          background: "linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)",
                          borderRight: "2px solid #c7d2fe",
                          color: "#3730a3",
                          minWidth: "240px",
                          position: "sticky",
                          top: 0,
                          left: 0,
                          zIndex: 11,
                        }}
                      >
                        <span>{t("Module")}</span>
                      </th>

                      {roleList.map((dataItem, index) => {
                        return (
                          <th
                            className={`${dataItem.name} text-gray fw-normal`}
                            key={index}
                            style={{
                              position: "sticky",
                              top: 0,
                              backgroundColor: "#fff",
                              boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
                            }}
                          >
                            <span>{dataItem.name}</span>
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  {roleList.length > 0 ? (
                    <tbody>
                      {groupedData.map(({ parent, children }, groupIndex) => {
                        const isExpanded = expandedParents.has(parent.moduleid);
                        const childCount = children.length;

                        return (
                          <Fragment key={parent.slug}>
                            {/* Parent Row */}
                            <tr
                              className="parent"
                              style={{ backgroundColor: "#f8f9fa" }}
                              onMouseEnter={() => setHoveredIndex(`p-${groupIndex}`)}
                              onMouseLeave={() => setHoveredIndex(null)}
                            >
                              <td
                                className="module"
                                style={{
                                  background: "linear-gradient(135deg, #eef2ff 0%, #e8edff 100%)",
                                  borderRight: "2px solid #c7d2fe",
                                  position: "sticky",
                                  left: 0,
                                  zIndex: 1,
                                }}
                              >
                                <div className="d-flex align-items-center gap-2">
                                  {/* Expand/collapse toggle */}
                                  {childCount > 0 ? (
                                    <span
                                      onClick={() => toggleExpand(parent.moduleid)}
                                      style={{
                                        cursor: "pointer",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "18px",
                                        fontSize: "10px",
                                        color: "#6c757d",
                                        flexShrink: 0,
                                        transition: "transform 0.2s ease",
                                        transform: isExpanded ? "rotate(90deg)" : "rotate(0deg)",
                                        userSelect: "none",
                                      }}
                                    >
                                      ▶
                                    </span>
                                  ) : (
                                    <span style={{ width: "18px", flexShrink: 0 }} />
                                  )}

                                  <span
                                    style={{
                                      width: "4px",
                                      height: "18px",
                                      background: "#0d6efd",
                                      borderRadius: "2px",
                                      flexShrink: 0,
                                    }}
                                  ></span>

                                  <span
                                    className={`fw-semibold ${hoveredIndex === `p-${groupIndex}` ? "text-primary" : ""}`}
                                    style={{ transition: "color 0.15s ease" }}
                                  >
                                    {parent.name}
                                  </span>

                                  {childCount > 0 && (
                                    <span className="badge bg-primary rounded-pill" style={{ fontSize: "11px" }}>
                                      {childCount}
                                    </span>
                                  )}
                                </div>
                              </td>

                              {parent.previleges.map((previlegeData, index2) => (
                                <td className={previlegeData.slug} key={index2}>
                                  <div className="form-check">
                                    <input
                                      className="form-check-input check-success border-black"
                                      type="checkbox"
                                      name={previlegeData.name}
                                      id={`${parent.slug}-${previlegeData.slug}`}
                                      checked={previlegeData.privilege}
                                      onChange={(e) =>
                                        changePrevilegeCheckHandler(e, previlegeData, parent)
                                      }
                                    />
                                  </div>
                                </td>
                              ))}
                            </tr>

                            {/* Child Rows — visible only when parent is expanded */}
                            {isExpanded &&
                              children.map((child, childIndex) => (
                                <tr
                                  className="children"
                                  key={child.slug}
                                  onMouseEnter={() => setHoveredIndex(`c-${groupIndex}-${childIndex}`)}
                                  onMouseLeave={() => setHoveredIndex(null)}
                                >
                                  <td
                                    className="module"
                                    style={{
                                      background: "#f5f7ff",
                                      borderRight: "2px solid #c7d2fe",
                                      position: "sticky",
                                      left: 0,
                                      zIndex: 1,
                                    }}
                                  >
                                    <div
                                      className="d-flex align-items-center gap-1"
                                      style={{ paddingLeft: "20px" }}
                                    >
                                      <span
                                        className={hoveredIndex === `c-${groupIndex}-${childIndex}` ? "text-primary" : "text-muted"}
                                        style={{ fontSize: "13px", lineHeight: 1, transition: "color 0.15s ease" }}
                                      >
                                        └
                                      </span>
                                      <span
                                        className={hoveredIndex === `c-${groupIndex}-${childIndex}` ? "text-primary" : "text-secondary"}
                                        style={{ transition: "color 0.15s ease" }}
                                      >
                                        {child.name}
                                      </span>
                                    </div>
                                  </td>

                                  {child.previleges.map((previlegeData, index2) => (
                                    <td className={previlegeData.slug} key={index2}>
                                      <div className="form-check">
                                        <input
                                          className="form-check-input check-success border-black"
                                          type="checkbox"
                                          name={previlegeData.name}
                                          id={`${child.slug}-${previlegeData.slug}`}
                                          checked={previlegeData.privilege}
                                          onChange={(e) =>
                                            changePrevilegeCheckHandler(e, previlegeData, child)
                                          }
                                        />
                                      </div>
                                    </td>
                                  ))}
                                </tr>
                              ))}
                          </Fragment>
                        );
                      })}
                    </tbody>
                  ) : null}
                </table>
              </div>
            )}
          </div>
        </section>
        <PreviledgeSuccessModal afterModalClose={getAllModulePrevileges} />
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default ModuleRolePrevilegeBody;
